import React, { Fragment } from "react";
import styles from "./index.module.scss";

export default function Index(props) {
  const { style, info } = props;
  return (
    <div className={styles.desc_container} style={style}>
      <div className={styles.desc_content}>
        <div className={styles.title}>{info ? info.title : ''}</div>
        {info && info.extra ? (
          <Fragment>
            <div className={styles.line}></div>
            <div className={styles.desc}>{info.extra}</div>
          </Fragment>
        ) : null}
      </div>
    </div>
  );
}
